module.exports = __webpack_public_path__ + "assets/img/vipIcon5.3f3f8650.png";